module.exports = __webpack_public_path__ + "img/filter-icon.2e5a5c0d.svg";